export const ToNonMembersSmsTypes = {
  GET_SMS_NON_MEMBERS: "GET_SMS_NON_MEMBERS",
  SEN_SMS_NON_MEMBERS_PREVIEW: "SEN_SMS_NON_MEMBERS_PREVIEW",
  SEN_SMS_NON_MEMBERS: "SEN_SMS_NON_MEMBERS",
};
